import { QuoteValue } from "./QuoteValue";
import { Asset } from "./Asset";
export class AssetValue {
    constructor(asset, value) {
        this.asset = asset;
        this.value = value;
    }
    static zero(mintId) {
        return new AssetValue(Asset.zero(mintId), QuoteValue.zero());
    }
    getMintId() {
        return this.getAsset().getMintId();
    }
    getAsset() {
        return this.asset;
    }
    getValue() {
        return this.value;
    }
}
//# sourceMappingURL=AssetValue.js.map